/* KOR-E social-networks feed — extracted from sections/kore-social-networks-feed.liquid
   (Batch AR). The card data stays inline as application/json; only behaviour moved. */
(function () {
  function init(bootCfg) {

  'use strict';
  /* Renamed from `cfg` (Batch AV): the section's own body declares `var cfg` for the parsed
     JSON payload a few lines below. `var cfg` over a parameter is a no-op so this worked, but
     any future edit that read cfg.sid after the JSON assignment would have silently broken. */
  var sid = bootCfg.sid;
  var root = document.getElementById('ksf-' + sid);
  if (!root) return;

  /* JS-gated card-image loading is handled by the shared utility
     assets/kore-gated-images.js (img[data-kore-gate-src]). */

  var dataEl = document.getElementById('ksf' + sid + '-data');
  if (!dataEl) return;
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var cards    = cfg.cards    || [];
  var initial  = cfg.initialCount || 6;
  var batch    = cfg.batchSize    || 6;
  var showCta  = cfg.showCta !== false;
  var defCta   = cfg.defaultCta || 'לצפייה בפוסט';

  var grid     = root.querySelector('.ksf' + sid + '-grid');
  var lmBtn    = root.querySelector('.ksf' + sid + '-lm-btn');
  var modal    = document.getElementById('ksf' + sid + '-modal');
  var mMedia   = modal.querySelector('.ksf' + sid + '-modal__media');
  var mContent = modal.querySelector('.ksf' + sid + '-modal__content');
  var mClose   = modal.querySelector('.ksf' + sid + '-modal__close');
  var mBack    = modal.querySelector('.ksf' + sid + '-modal__backdrop');
  var btnPrev  = document.getElementById('ksf' + sid + '-prev');
  var btnNext  = document.getElementById('ksf' + sid + '-next');

  var cardEls = Array.from(grid.querySelectorAll('.ksf' + sid + '-card'));
  var shown   = Math.min(initial, cardEls.length);

  /* Initially hide cards beyond initial count */
  cardEls.forEach(function (c, i) { if (i >= shown) c.setAttribute('hidden', ''); });
  if (shown >= cardEls.length && lmBtn) lmBtn.setAttribute('hidden', '');

  /* Load more */
  if (lmBtn) {
    lmBtn.addEventListener('click', function () {
      var target = Math.min(shown + batch, cardEls.length);
      for (var i = shown; i < target; i++) {
        cardEls[i].removeAttribute('hidden');
        void cardEls[i].offsetWidth; /* reflow for animation */
        cardEls[i].classList.add('ksf' + sid + '-card--reveal');
      }
      shown = target;
      if (shown >= cardEls.length) lmBtn.setAttribute('hidden', '');
    });
  }

  /* Platform SVGs (white fill for modal badge) */
  var SVG = {
    instagram: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>',
    tiktok:    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.87a8.18 8.18 0 0 0 4.78 1.52V7a4.85 4.85 0 0 1-1.01-.31z"/></svg>',
    facebook:  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" aria-hidden="true"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>'
  };
  var SVG_EXT = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M14 3h7v7h-2V6.414l-9.293 9.293-1.414-1.414L17.586 5H14V3zM3 5h8v2H5v12h12v-6h2v8H3V5z"/></svg>';

  function platformSVG(p) { return SVG[p] || SVG.instagram; }

  function esc(v) {
    return String(v || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Modal ── */
  var currentIdx = 0;
  var lastFocus  = null;

  function openModal(idx) {
    if (idx < 0 || idx >= cards.length) return;
    currentIdx = idx;
    lastFocus  = document.activeElement;
    populate(cards[idx]);
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    updateArrows();
    mClose && mClose.focus();
  }

  function closeModal() {
    stopVideo();
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (btnPrev) btnPrev.setAttribute('hidden', '');
    if (btnNext) btnNext.setAttribute('hidden', '');
    if (lastFocus) { try { lastFocus.focus(); } catch(e) {} }
  }

  function goTo(idx) {
    if (idx < 0 || idx >= cards.length) return;
    stopVideo();
    currentIdx = idx;
    populate(cards[idx]);
    updateArrows();
  }

  function stopVideo() {
    var vid = mMedia.querySelector('video');
    if (vid) { vid.pause(); vid.src = ''; vid.load(); }
  }

  function updateArrows() {
    if (btnPrev) {
      if (currentIdx <= 0) btnPrev.setAttribute('hidden', '');
      else btnPrev.removeAttribute('hidden');
    }
    if (btnNext) {
      if (currentIdx >= cards.length - 1) btnNext.setAttribute('hidden', '');
      else btnNext.removeAttribute('hidden');
    }
  }

  function populate(card) {
    /* Apply per-card media aspect ratio (mobile only; desktop overrides via CSS) */
    mMedia.style.setProperty('--ksf-media-ratio', card.mediaRatio || '1 / 1');

    /* Media panel */
    if (card.mediaType === 'video' && card.videoUrl) {
      mMedia.innerHTML =
        '<video src="' + esc(card.videoUrl) + '"' +
        (card.posterUrl ? ' poster="' + esc(card.posterUrl) + '"' : '') +
        ' controls playsinline preload="metadata"' +
        ' style="width:100%;height:100%;object-fit:cover;display:block;"></video>';
    } else {
      var src = card.thumbUrl || card.posterUrl || '';
      mMedia.innerHTML = src
        ? '<img src="' + esc(src) + '" alt="' + esc(card.altText) + '" style="width:100%;height:100%;object-fit:cover;display:block;">'
        : '<div style="width:100%;height:100%;min-height:200px;display:flex;align-items:center;justify-content:center;background:#1a1a1a;">' + platformSVG(card.platform) + '</div>';
    }

    /* Content panel */
    var avatarHtml = card.profileUrl
      ? '<img class="ksf' + sid + '-modal__avatar" src="' + esc(card.profileUrl) + '" alt="" aria-hidden="true" loading="lazy">'
      : '';

    var handleHtml = card.handle
      ? '<span class="ksf' + sid + '-modal__handle">' + esc(card.handle) + '</span>'
      : '';

    var badgeHtml =
      '<div class="ksf' + sid + '-modal__platform-badge">' + platformSVG(card.platform) + '</div>';

    var titleHtml = card.title
      ? '<p class="ksf' + sid + '-modal__title">' + esc(card.title) + '</p>'
      : '';

    var captionHtml = card.caption
      ? '<p class="ksf' + sid + '-modal__caption">' + esc(card.caption) + '</p>'
      : '';

    var ctaHtml = '';
    if (showCta && card.postUrl) {
      ctaHtml =
        '<a href="' + esc(card.postUrl) + '"' +
        (card.newTab ? ' target="_blank" rel="noopener noreferrer"' : '') +
        ' class="ksf' + sid + '-modal__cta">' +
        esc(card.ctaLabel || defCta) + SVG_EXT + '</a>';
    }

    mContent.innerHTML =
      '<div class="ksf' + sid + '-modal__handle-row">' +
        '<div class="ksf' + sid + '-modal__handle-group">' + avatarHtml + handleHtml + '</div>' +
        badgeHtml +
      '</div>' +
      '<div class="ksf' + sid + '-modal__divider"></div>' +
      titleHtml + captionHtml + ctaHtml;
  }

  /* Event wiring */
  if (mClose) mClose.addEventListener('click', closeModal);
  if (mBack)  mBack.addEventListener('click', closeModal);
  if (btnPrev) btnPrev.addEventListener('click', function () { goTo(currentIdx - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { goTo(currentIdx + 1); });

  document.addEventListener('keydown', function (e) {
    if (modal.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'ArrowRight') goTo(currentIdx - 1); /* RTL: right = prev */
    if (e.key === 'ArrowLeft')  goTo(currentIdx + 1); /* RTL: left  = next */
  });

  cardEls.forEach(function (c, i) {
    c.addEventListener('click', function () { openModal(i); });
    c.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(i); }
    });
  });


  }
  function boot() { var q = window.__koreKSF || []; (q.forEach ? q : []).forEach(init); window.__koreKSF = { push: init }; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
}());
